<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 产品管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>产品分类</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <div class="container" > 
            <div class="handle-box" style="overflow-y:hidden;">  
                <span class="label-span">
                    <label class="label">预警计划名称</label> 
                    <el-input v-model.trim="query.name" placeholder="预警计划名称" class="handle-input mr15"></el-input> 
                </span>
                <span class="label-span">
                    <label class="label">计划状态</label> 
                    <el-select v-model="query.status"  placeholder="计划状态" clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />  
                        <el-option value="1" label="启用"  /> 
                        <el-option value="0" label="停用"  /> 
                    </el-select>
                </span>   
                <el-button icon="el-icon-search"  class="mr10"  @click="handleSearch">搜索</el-button>
                <el-button icon="el-icon-refresh" class="mr10" style="margin-right:25px;"  @click="refreshSearch">重置</el-button>
                <el-button  type="primary"  icon="el-icon-lx-roundadd" class="mr10"  @click="addBind" >新增预警计划</el-button> 
               
               
            </div>
            <el-table :data="tableData" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <!--<el-table-column type="selection" width="35" align="center"></el-table-column>--> 
                <el-table-column prop="id" width="80" align="left" label="计划ID"> </el-table-column>     
                <el-table-column prop="name" min-width="100" align="left" label="预警计划名称"> </el-table-column>     
                <el-table-column prop="descript" min-width="120" align="left" label="预警计划描述"> </el-table-column>     
                <el-table-column prop="status" min-width="80" align="center" label="计划状态">
                    <template slot-scope="scope" >   
                        <el-tooltip :content="scope.row.status=='1'?'计划已开启':'计划已关闭'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template> 
                </el-table-column>  
                <el-table-column prop="status" min-width="130" align="left" label="接口请求范围">
                    <template slot-scope="scope" >   
                        
                        <div v-for="(item,index) in scope.row.config" :key="index"> 
                            <el-tag style="background:none;"> {{item.range1}}次 <span style="margin:0 8px;font-size:15px;">~</span> {{item.range2}}次</el-tag>  
                        </div>  
                    </template> 
                </el-table-column>  
                <el-table-column prop="status" min-width="100" align="left" label="转化率要求">
                    <template slot-scope="scope" >   
                        
                        <div v-for="(item,index) in scope.row.config" :key="index"> 
                            <el-tag type="success">{{item.rangeLimit}}%</el-tag>   
                        </div>  
                    </template> 
                </el-table-column>  
                <el-table-column prop="createTime" width="160" align="center"  label="创建时间"> </el-table-column>  
                <el-table-column label="操作" min-width="180" align="center"  fixed="right">
                    <template slot-scope="scope"> 
                        <el-button-group>
                        <el-button  type="primary" plain @click="handleEdit(scope.$index, scope.row)" >编辑</el-button>   
                       <el-button  type="danger" plain  @click="handDelete(scope.$index, scope.row)" >删除</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
                  
            </el-table>
            <div class="pagination">
                <el-pagination 
                   background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </div> 
        <!-- 新建自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="新增计划" :visible.sync="addVisible" :modal-append-to-body='false' top="80px" width="560px">
            <el-form ref="form1" :model="form1" label-width="120px"  @submit.native.prevent="saveForm">
                <el-form-item label="预警计划名称">
                    <el-input v-model.trim="form1.name"  placeholder="不超过10个字"  ></el-input>
                </el-form-item> 
                <el-form-item label="预警计划描述">
                    <el-input v-model.trim="form1.descript"  placeholder="不超过50个字"  ></el-input>
                </el-form-item>  
                <el-form-item label="接口预警转化" style="margin-bottom:20px">
                    <el-button type="primary" @click="add">添加转化区间</el-button>
                </el-form-item> 
                <div v-for="(item,index) in array" :key="index"> 
                    <el-form-item label="" style="margin-top:-12px">
                        <el-input v-model.trim="form1.range1[index]" oninput ="value=value.replace(/[^\d]/g,'')" placeholder="最小请求值" style="width:100px;display:inline-block;"></el-input> -
                        <el-input v-model.trim="form1.range2[index]" oninput ="value=value.replace(/[^\d]/g,'')" placeholder="最大请求值" style="width:100px;display:inline-block;"></el-input> 
                        <el-input v-model.trim="form1.rangeLimit[index]" oninput="value=value.replace(/[^0-9.]/g,'')" placeholder="转化比例"  style="width:85px;display:inline-block;margin-left:20px;"></el-input> %  
                        <el-button type="danger" size="small" style="margin-left:15px;" icon="el-icon-delete" @click="del(index)"></el-button> 
                    </el-form-item> 
                </div>  
            </el-form>
            <span slot="footer" class="dialog-footer" align="center" >
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog>
         
  

        <!-- 编辑自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="编辑计划" :visible.sync="editVisible" :modal-append-to-body='false' top="50px" width="580px">
            <el-form ref="form3" :model="form3" label-width="120px">
                <el-form-item label="预警计划名称">
                    <el-input v-model.trim="form2.name"  placeholder="不超过10个字" ></el-input>
                </el-form-item> 
                <el-form-item label="预警计划描述">
                    <el-input v-model.trim="form2.descript"  placeholder="不超过50个字" ></el-input>
                </el-form-item>    
                <el-form-item label="接口预警转化" style="margin-bottom:20px">
                    <el-button type="primary" @click="add2">添加转化区间</el-button>
                </el-form-item> 
                <div v-for="(item,index) in form2.config" :key="index"> 
                    <el-form-item label="" style="margin-top:-12px">
                        <el-input v-model.trim="form2.config[index].range1" oninput ="value=value.replace(/[^\d]/g,'')" placeholder="最小请求值" style="width:100px;display:inline-block;"></el-input> -
                        <el-input v-model.trim="form2.config[index].range2" oninput ="value=value.replace(/[^\d]/g,'')" placeholder="最大请求值" style="width:100px;display:inline-block;"></el-input> 
                        <el-input v-model.trim="form2.config[index].rangeLimit" oninput="value=value.replace(/[^0-9.]/g,'')" placeholder="转化比例"  style="width:85px;display:inline-block;margin-left:20px;"></el-input> %  
                        <el-button type="danger" size="small" style="margin-left:15px;" icon="el-icon-delete" @click="del2(index)"></el-button> 
                    </el-form-item> 
                </div>   
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
          
    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,changeForm,changeStatus,fetchDataDir} from '../../api/comApilimit'; 
export default {

    data() {
        return {  
            isSubmitting: false, // 是否正在提交
            Timeout:'', 
            activeNames:1,
            select:{ option:'',  },
            sendSms:{
                code:'', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            array:[1],
            query: { 
                pageIndex: 1,
                pageSize: 10,  
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            dirVisible:false,
            row:{},
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                range1:[],
                range2:[], 
                rangeLimit:[]
            },
            form2: {   },
            form3: {   },
            form4: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.getData();  
    },

    methods: {  
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'name', '');  
            this.$set(this.query, 'status');    
            this.handleSearch();
        }, 
        add(){
            this.array.push(1)  //通过添加array的值，增加input的个数
        },
        
       
        add2(){
            var config = {range1:'',range2:'',rangeLimit:''};
            this.form2.config.push(config)  //通过添加array的值，增加input的个数
        },
        del2(index){ 
            this.form2.config.splice(index,1); //然后删除array对应索引的值，实现点击删除按钮，减少input框效果
        },

        //触发刷新按钮
        refresh(){
            history.go(0);
            
        }, 

        //查询
        getData(){ 
            this.query.conType = '2';    
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
        //渠道字典表
        channelDir(){
            this.dirVisible=true;
            fetchDataDir(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData2 = res.data;   
                }else{
                    this.$message("暂无数据");
                } 
                
            });

        },
       

        // 新增渠道
        addBind() {
            this.addVisible = true; 
        },
        //保存新增
        saveForm() {   
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.name ){
                this.isSubmitting = false;
                this.$message.error("请填写预警计划名称");
                return;
            }  
            if(this.array.length==0){
                this.isSubmitting = false;
                this.$message.error("请添加转化区间");
                return;
            }
            for(var i=0;i<this.array.length;i++){
                if( !this.form1.range1[i] || this.form1.range1[i]=='' ){
                    this.isSubmitting = false; 
                    this.$message.error("请填写第 "+(i+1)+" 行中-请求最小值");
                    return;
                }  
                if( !this.form1.range2[i] || this.form1.range2[i]=='' ){
                    this.isSubmitting = false;
                    this.$message.error("请填写第 "+(i+1)+" 行中-请求最大值");
                    return;
                }  
                if( !this.form1.rangeLimit[i] || this.form1.rangeLimit[i]=='' ){
                    this.isSubmitting = false;
                    this.$message.error("请填写第 "+(i+1)+" 行中-转化比例");
                    return;
                }  
            }
            this.form1.conType = '2';
            this.form1.range1s = this.form1.range1.join();
            this.form1.range2s = this.form1.range2.join();
            this.form1.rangeLimits = this.form1.rangeLimit.join();
            this.loading = true; 
            this.addVisible = false; 
            saveForm(this.form1).then(res => {
                this.loading = false;  
                if(res.code=='200'){  
                    this.$message.success(res.message); 
                    this.refreshSearch(); 
                }else{
                    this.addVisible = true;
                    this.$message.error(res.message); 
                } 
                this.isSubmitting = false;
            });
        },

        

        // 编辑操作
        handleEdit(index, row) {      
            this.editVisible = true;
            this.form2 = row; 
        },
 
        
        // 保存更改
        saveEdit() { 
            if( !this.form2.name ){ 
                this.$message.error("请填写预警计划名称");
                return;
            }  
            if(this.form2.config.length==0){ 
                this.$message.error("请添加转化区间");
                return;
            }
            for(var i=0;i<this.form2.config.length;i++){
                if( !this.form2.config[i].range1 || this.form2.config[i].range1=='' ){ 
                    this.$message.error("请填写第 "+(i+1)+" 行中-请求最小值");
                    return;
                }  
                if( !this.form2.config[i].range2 || this.form2.config[i].range2=='' ){ 
                    this.$message.error("请填写第 "+(i+1)+" 行中-请求最大值");
                    return;
                }  
               if( !this.form2.config[i].rangeLimit || this.form2.config[i].rangeLimit=='' ){ 
                    this.$message.error("请填写第 "+(i+1)+" 行中-转化比例");
                    return;
                }  
            }  
            this.form2.configs = JSON.stringify(this.form2.config);
            changeForm(this.form2).then(res => {
                if(res.code=='200'){
                    this.editVisible = false; 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {  
             var tips ;
            var content;
            if(row.status=='0'){ 
                row.status='1';
                tips = "禁用";
                content = "确定禁用吗？";
            }else{ 
                row.status = '0';
                tips = "启用";
                content = "确定启用吗？"; 
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => { 
                if(row.status=='0'){ 
                    row.status='1' 
                }else{ 
                    row.status='0' 
                }
                changeStatus(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success(tips+'成功'); 
                        this.getData();
                    }else{ 
                        if(row.status=='0'){ 
                            row.status='1' 
                        }else{ 
                            row.status='0' 
                        }
                        this.$message.error(tips+'失败');
                    } 
                });
            })
            .catch(() => {}); 
           
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {  
            if(row.id==1 || row.id==2){
                this.$message.error("默认计划不可删除！"); 
                return;
            }
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.$set(this.query, 'pageIndex', 1); 
                        this.getData();
                    }else if(res.code=='201'){
                        //处理该等级绑定的成员
                        this.$message.error("有渠道绑定了该风控计划，请解除绑定后再进行删除！"); 
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
  .label-span{
      display: inline-block;
      height: 45px;
  }
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
